function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import PropTypes from 'prop-types';
import { hoistStatics } from 'recompose';
import withBreakPoint from "./withBreakPoint";
import { breakPoint as breakPointAlt } from "../../styles/theme";
var breakPointKeys = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
var checklistConfig = {
  sm: ['xs'],
  md: ['sm', 'xs'],
  lg: ['md', 'sm', 'xs'],
  xl: ['lg', 'md', 'sm', 'xs'],
  xxl: ['xl', 'lg', 'md', 'sm', 'xs']
};
/**
 * If current breakpoint is lg, look for the config in the following order md => sm  => xs
 */

function getClosestAttributesByBreakPoint(_ref) {
  var breakPoint = _ref.breakPoint,
      responsiveConfig = _ref.responsiveConfig;

  if (breakPoint === 'xs' || breakPointKeys.indexOf(breakPoint) === -1) {
    return {};
  }

  var checklist = checklistConfig[breakPoint];

  for (var i = 0; i < checklist.length; i += 1) {
    var config = responsiveConfig[checklist[i]];

    if (config) {
      return config;
    }
  }

  return {};
}
/**
 * A HOC to allow config for different device sizes
 * If the config is not present, we'll find the next closest config in the lower range
 * Sample usage:
 * <ResponsiveComponent responsiveConfig={{
 *  sm: {
 *    name: 'Small',
 *    size: 2,
 *  },
 *  lg: {
 *    name: 'Large',
 *    size: 4,
 *  }
 * }}>
 */


var withResponsiveConfig = function withResponsiveConfig(Component) {
  var HOC = function HOC(_ref2) {
    var breakPoint = _ref2.breakPoint,
        _ref2$responsiveConfi = _ref2.responsiveConfig,
        responsiveConfig = _ref2$responsiveConfi === void 0 ? {} : _ref2$responsiveConfi,
        rest = _objectWithoutProperties(_ref2, ["breakPoint", "responsiveConfig"]);

    var attributesByBreakpoint = responsiveConfig[breakPoint];

    if (!attributesByBreakpoint) {
      attributesByBreakpoint = getClosestAttributesByBreakPoint({
        breakPoint: breakPoint,
        responsiveConfig: responsiveConfig
      });
    }

    return React.createElement(Component, _extends({}, attributesByBreakpoint, rest));
  };

  HOC.propTypes = {
    // ['xs', 'sm', 'md', 'lg', 'xl', 'xxl']
    breakPoint: PropTypes.oneOf(Object.keys(breakPointAlt)),
    responsiveConfig: PropTypes.object
  };
  var componentName = Component.displayName || Component.name;
  HOC.displayName = "HOC(".concat(componentName, ")");
  hoistStatics(Component, HOC);
  return withBreakPoint(HOC);
};

export default withResponsiveConfig;